import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';

import { navigateToPayment } from '../actions/stepper-actions';
import { payInvoice as onPayInvoice } from '../actions/payment-actions';
import { setTestId } from '../util/testUtils';

const styles = (theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    margin: theme.spacing(3, 1, 2),
    width: '98%',
  },
  title: {
    marginTop: theme.spacing(8),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  grid: {
    textAlign: 'left',
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  balance: {
    fontWeight: 'bold',
  },
});

class Review extends React.Component {
  static propTypes = {
    cardNumber: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    handleNavigateToPayment: PropTypes.func.isRequired,
    isPosting: PropTypes.bool.isRequired,
    payInvoice: PropTypes.func.isRequired,
    paymentAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paymentError: PropTypes.string,
    invoice: PropTypes.shape({
      balanceDue: PropTypes.number,
      invoiceId: PropTypes.number,
      lineItemDesc: PropTypes.string,
      poNumber: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    paymentError: null,
    paymentAmount: 0.0,
  };

  renderPO = (poNumber) => {
    if (poNumber) {
      return (
        <React.Fragment>
          <Grid item xs={6}>
            <Typography gutterBottom>Purchase Order Number</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography align="right" gutterBottom>
              {poNumber}
            </Typography>
          </Grid>
        </React.Fragment>
      );
    }

    return null;
  };

  render() {
    const {
      paymentAmount,
      classes,
      invoice,
      payInvoice,
      cardNumber,
      isPosting,
      paymentError,
      handleNavigateToPayment,
    } = this.props;

    const { invoiceId, poNumber } = invoice;

    const paymentAmountDisplay = parseFloat(paymentAmount).toFixed(2);

    return (
      <div className={classes.paper}>
        <Grid className={classes.grid} container>
          <Grid item xs={6}>
            <Typography gutterBottom>Invoice Number</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography align="right" gutterBottom {...setTestId('invoiceId')}>
              {invoiceId}
            </Typography>
          </Grid>
          {this.renderPO(poNumber)}
          <Grid item xs={6}>
            <Typography gutterBottom>Amount</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              align="right"
              gutterBottom
              {...setTestId('paymentAmountDisplay')}
            >
              {`$ ${paymentAmountDisplay}`}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography gutterBottom>Card Number</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography align="right" gutterBottom>
              {cardNumber}
            </Typography>
          </Grid>
        </Grid>
        <Typography className={classes.title}>
          Please review the payment and invoice details carefully. By clicking
          &quot;Pay Invoice,&quot; you are authorizing Text-Em-All to charge
          this card. This action cannot be undone.
        </Typography>
        <Grid container>
          <Grid item xs={6}>
            <Button
              {...setTestId('back')}
              className={classes.button}
              onClick={handleNavigateToPayment}
              variant="outlined"
            >
              Back
            </Button>
          </Grid>
          <Grid align="right" item xs={6}>
            <Button
              {...setTestId('payInvoice')}
              className={classes.button}
              color="primary"
              disabled={isPosting ? true : undefined}
              onClick={payInvoice}
              variant="contained"
            >
              {isPosting ? (
                <CircularProgress color="inherit" size={25} />
              ) : (
                'Pay Invoice'
              )}
            </Button>
          </Grid>
        </Grid>
        {paymentError && (
          <Typography align="center" color="error">
            {paymentError}
          </Typography>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { invoice, payment } = state;

  const { ccDisplay: cardNumber } = payment;

  return {
    invoice,
    paymentAmount: payment.paymentAmount,
    isPosting: payment.isPosting,
    paymentError: payment.paymentError,
    cardNumber,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handleNavigateToPayment: navigateToPayment,
      payInvoice: onPayInvoice,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Review));
